import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import useResource, { STATUS_LOADING, STATUS_SUCCEEDED } from 'src/presentation/hooks/useResource';
import integrationsResource from 'src/actions/integrations/integrationsResource';
import isThreadDependencySatisfied from './helpers/isThreadDependencySatisfied';

import useDocumentResource from 'src/presentation/hooks/useDocumentResource';
import threadResource from 'src/actions/threads/threadResource';
import ThreadEditorForm from './ThreadsEditorForm';
import { Spinner } from 'src/presentation/components/pages/shared/Spinner';

const ThreadsEditor = ({ actionsRef, errors, item, root }) => {
  const { loadingState: externalSourcesLoadingState, values: externalSources = [] } = useResource(integrationsResource);
  const dispatch = useDispatch();

  const [loaded, setLoaded] = useState(false);

  const { loadingState, value: thread } = useDocumentResource(threadResource, { fetch: false });

  useEffect(() => {
    if (!item) {
      setLoaded(true);
      return;
    }

    if (
      loadingState === STATUS_SUCCEEDED &&
      thread.id === item.id &&
      thread.version === item.version &&
      externalSourcesLoadingState === STATUS_SUCCEEDED
    ) {
      setLoaded(true);
      return;
    }

    if (loadingState !== STATUS_LOADING) {
      dispatch(threadResource.effects.fetch({ id: item.id, version: item.version }));
    }
  }, [dispatch, item, thread, loadingState, setLoaded, externalSourcesLoadingState]);

  return loaded ? (
    <ThreadEditorForm
      actionsRef={actionsRef}
      errors={errors}
      item={item ? thread : undefined}
      root={root}
      isThreadDependencySatisfied={isThreadDependencySatisfied(externalSources)}
    />
  ) : (
    <Spinner />
  );
};

export default ThreadsEditor;
